//--- React
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
//--- Ant Design
import { Col, Row } from "antd";
//--- Project
import { TEST_RIDE_SUMMARY } from "components/Common/Grafana/Constants";
import { UNITS } from "components/Common/Constants";
import ChartFilter from "components/Common/ChartFilter";
import PanelsRow from "components/Common/Grafana/PanelsRow";
import panelList from "../panelList.json";
import BatteryPerformance from "./Battery";

const SpeedAnalytics = ({ baseUrl, baseFilterObject }) => {
  const tripSummary = useSelector((state) => state.testRide.tripSummary);
  const [chartType, setChartType] = useState({
    timeSeries: true,
    histogram: false,
    boxPlot: false,
  });
  const [speedList, setSpeedList] = useState([]);

  useEffect(() => {
    setSpeedList(panelList?.speed);
  }, []);

  const updateChartType = (name, value) => {
    setChartType((prev) => ({ ...prev, [name]: value }));
  };

  const subContent = (
    <>
      <Row gutter={[16, 16]} justify="end" className="mt1">
        <Col xs={8} sm={6} md={4} lg={3} xl={3}>
          <ChartFilter
            updateChartType={updateChartType}
            chartType={chartType}
          />
        </Col>
      </Row>
      <div className="grey-box mt105">
        <Row gutter={[16, 16]} justify="center">
          <Col xs={24} sm={24} md={24} lg={8} xl={8} className="flex-center">
            Average:
            <span className="ml025 bold">{tripSummary?.averageSpeed}</span>
            <span className="ml025">{UNITS.KM_PER_HR}</span>
          </Col>
          <Col xs={24} sm={24} md={24} lg={8} xl={8} className="flex-center">
            Statistical Mode:
            <span className="ml025 bold">
              {tripSummary?.statisticalModeOfSpeed}
            </span>
            <span className="ml025">{UNITS.KM_PER_HR}</span>
          </Col>
          <Col xs={24} sm={24} md={24} lg={8} xl={8} className="flex-center">
            Top Value:
            <span className="ml025 bold">{tripSummary?.topSpeed}</span>
            {/* <span className="ml025">{UNITS.KM_PER_HR}</span> */}
          </Col>
        </Row>
      </div>
    </>
  );

  return (
    <>
      {subContent}
      <Row className="pd0">
        {speedList?.map((panel, index) => (
          <Col key={index} span={24}>
            <PanelsRow
              title={panel.title}
              url={baseUrl}
              timeSeriesPanel={
                chartType?.timeSeries &&
                TEST_RIDE_SUMMARY.PANEL_ID[panel.var_name]["timeSeries"]
              }
              histogramPanel={
                chartType?.histogram &&
                TEST_RIDE_SUMMARY.PANEL_ID[panel.var_name]["histogram"]
              }
              boxPlotPanel={
                chartType?.boxPlot &&
                TEST_RIDE_SUMMARY.PANEL_ID[panel.var_name]["boxPlot"]
              }
              baseFilterObject={baseFilterObject}
              variableKeys={TEST_RIDE_SUMMARY.BASE_VARIABLES}
            />
          </Col>
        ))}
      </Row>

      <BatteryPerformance
        baseUrl={baseUrl}
        baseFilterObject={baseFilterObject}
        chartType={chartType}
      />
    </>
  );
};

export default SpeedAnalytics;
